import { useTranslations } from 'next-intl';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MaintenanceClouds } from '@/app/[locale]/maintenance/components/MaintenanceClouds';
import { Beardman404 } from '~/components/Beardman/Beardman404/Beardman404';
import { TabsFilterValue } from '../../types/project/tabs';
import { InteractionDetail } from '../interaction/InteractionDetail';
import { useProjectInteractionsContext } from '../provider/ProjectInteractionsProvider';

export function ProjectOngoingInteractionList() {
  const t = useTranslations('PROJECT.ONGOING');
  const { collections, fetchInteractions } = useProjectInteractionsContext();

  const interactions = collections[TabsFilterValue.ONGOING]['hydra:member'];
  const nextPage = collections[TabsFilterValue.ONGOING]['hydra:view']?.['hydra:next'];

  return (
    <InfiniteScroll
      dataLength={interactions?.length || 0}
      next={async () => await fetchInteractions(
        TabsFilterValue.STEPS,
        nextPage,
      )}
      hasMore={!!nextPage}
      loader={null}
      style={{ height: 'initial', overflow: 'visible' }}
    >
      {interactions?.map(item => (
        <div
          className="ongoing-interactions__item"
          key={`${TabsFilterValue.ONGOING}-${item.id}`}
        >
          <InteractionDetail interaction={item} />
        </div>
      ))}
      {!interactions?.length && (
        <div className="maintenance-page__wrapper">
          <div className="maintenance-page__message">
            <p className="vp-title-m">
              {t.rich('NO_INTERACTION')}
            </p>
            <Beardman404 />
            <MaintenanceClouds />
          </div>
        </div>
      )}
    </InfiniteScroll>
  );
}
